import { ArrowUpRight, Radio, Music } from "lucide-react";
import { Reveal } from "./Reveal";

const CAMUP_URL = "https://camup.live/timbaland";
const PREVIEW = "https://customer-assets-agu9un31.emergentagent.net/job_timbodaking-media/artifacts/778vq8i9_image.png";

export default function CamUp() {
  return (
    <section className="relative overflow-hidden bg-obsidian py-24 md:py-36 border-t border-white/10" data-testid="camup-section">
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden
        style={{ background: "radial-gradient(circle at 22% 35%, rgba(79,176,74,0.18), transparent 55%)" }}
      />
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Preview image */}
        <Reveal className="md:col-span-5">
          <a
            href={CAMUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="camup-image-link"
            className="group relative block overflow-hidden rounded-xl border border-white/10 shadow-[0_0_60px_-15px_rgba(79,176,74,0.5)]"
          >
            <img
              src={PREVIEW}
              alt="Build your own live show like Timbaland on CamUp"
              className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute top-4 left-4 inline-flex items-center gap-2 bg-red-600 text-white font-display uppercase tracking-[0.18em] text-[0.62rem] px-3 py-1.5 rounded-full">
              <span className="w-2 h-2 rounded-full bg-white animate-pulse" /> Live
            </span>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        </Reveal>

        {/* Content */}
        <div className="md:col-span-7">
          <Reveal>
            <p className="overline text-gold mb-5 flex items-center gap-3">
              <Radio size={16} /> Live Broadcast · CamUp
            </p>
            <h2 className="headline text-5xl md:text-7xl text-white leading-[0.95] mb-3">CamUp</h2>
            <p className="font-display uppercase tracking-[0.22em] text-xs text-white/45 mb-8">Formerly TimboIdo</p>
            <p className="font-body text-white/65 text-lg md:text-xl leading-relaxed max-w-2xl mb-10">
              Step inside Timbaland's live room. CamUp is where Tim builds shows in real time, reacts to fresh
              submissions, and pulls up-and-coming artists straight onto the stage. Tune in when he goes live, or drop
              your music for a shot at his ear.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={CAMUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="camup-join-btn"
                className="group inline-flex items-center gap-3 bg-gold text-black font-display uppercase tracking-[0.2em] text-sm px-9 py-4 hover:bg-white transition-colors duration-300 rounded-full"
              >
                Join the Live
                <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </a>
              <a
                href={CAMUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="camup-submit-btn"
                className="group inline-flex items-center gap-3 border border-white/25 text-white font-display uppercase tracking-[0.2em] text-sm px-9 py-4 hover:bg-white/10 transition-colors duration-300 rounded-full"
              >
                <Music size={18} /> Submit Your Music
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
